/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {AppStore} from "../../stores/app.store";
import {useAppStore} from "../../common/app.store.consumer";
import {DebugPanelOperation} from "../../stores/debug.panel.store";
import {RouteComponentProps, withRouter} from "react-router";
import {ActionButton} from "../../common/action.button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ProfessionalProfileRoutes} from "../../stores/site.map";

export type DebugPanelProps = {appStore?: AppStore} & RouteComponentProps<{}>;

@useAppStore()
export class DebugPanelWithoutWrapper extends React.Component<DebugPanelProps> {
	private store = this.props.appStore.debugPanelStore;
	private userStore = this.props.appStore.userStore;

	private logout = async () => {
		if (this.props.appStore.configuration.isOpenIdLoginEnabled) {
			this.props.appStore.userStore.sendToOpenIdLogout();
		} else {
			await this.store.logout();
			this.props.history.push("/empty");
			this.props.history.replace("/");
		}
	};

	private generateTestPfd = async () => {
		const fileContent = await this.store.getGeneratedPdfFile();
		const csvURL = window.URL.createObjectURL(fileContent.data);
		let tempLink = document.createElement("a");
		tempLink.href = csvURL;
		tempLink.setAttribute("download", "test_report.pdf");
		tempLink.click();
	};

	render() {
		const {pathname} = this.props.location;

		let isEnabled = this.props.appStore.configuration.isDebugPanelEnabled;
		let isVisible = this.store.debugPanelVisible;

		let content = (
			<>
				<div className="test_panel_toggle cih-hide-print" onClick={this.store.toggleTestingPanel}>
					DEMO
				</div>
				{isVisible && (
					<div className="test_panel_wrap">
						<div className="pos-rel">
							<div className="test_panel">
								<div className="tp_tabs">
									<a style={{cursor: "pointer"}}>Actions</a>
									<a className="btn-link tab-close" onClick={this.store.toggleTestingPanel}>
										<FontAwesomeIcon transform="shrink-2" icon={["fas", "times"]} />
									</a>
								</div>
								{this.userStore.isLoggedIn && (
									<div>
										<div className="vspace10"></div>
										<div className="tp-title">User actions</div>
										<label className="tp_label">
											Logout
											<ActionButton className="cih-btn-dbg" onClick={this.logout} operation={DebugPanelOperation.Logout} />
										</label>

										{pathname.includes(ProfessionalProfileRoutes.ReportV2) ||
											(pathname.includes(ProfessionalProfileRoutes.Report) && (
												<>
													<div className="vspace10"></div>
													<div className="tp-title">PDF generation</div>
													<label className="tp_label">
														Generate test pdf
														<ActionButton className="cih-btn-dbg" onClick={this.generateTestPfd} operation={DebugPanelOperation.GenerateTestPdf} />
													</label>
												</>
											))}
									</div>
								)}
								<div style={{textAlign: "center", width: "100%"}}>
									<button className="cih-btn-dbg" style={{margin: "1.5em auto", width: "auto"}} onClick={this.store.toggleTestingPanel}>
										Close demo helper
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
		return isEnabled && content;
	}
}

export const PublicDebugPanel = withRouter(DebugPanelWithoutWrapper);
